export const APP_NAME = 'app-resource-user-dashboard-v2'; // process.env.npm_package_name
export const APP_CONTAINER = `${APP_NAME}__container`;
export const APP_PATH = '/my-resources';
